import { render, staticRenderFns } from "./tjdjDetail.vue?vue&type=template&id=3600f46c&scoped=true"
import script from "./tjdjDetail.vue?vue&type=script&lang=js"
export * from "./tjdjDetail.vue?vue&type=script&lang=js"
import style0 from "./tjdjDetail.vue?vue&type=style&index=0&id=3600f46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600f46c",
  null
  
)

export default component.exports